import { NotificationType } from '../enums';
import { MAIL_TEMPLATE_KEYS } from './mail-templates';
import { formatCoursePurchaseAmount } from '../courses/course-notifications';

/** Maps in-app notification types to dedicated admin mail templates (null → generic immediate). */
export function mailTemplateKeyForNotificationType(type: NotificationType): string | null {
  switch (type) {
    case NotificationType.COURSE_ENROLLED:
      return MAIL_TEMPLATE_KEYS.COURSE_ENROLLED;
    case NotificationType.COURSE_PURCHASE_RECEIPT:
      return MAIL_TEMPLATE_KEYS.COURSE_PURCHASE_RECEIPT;
    case NotificationType.COURSE_DRIP_UNLOCK:
      return MAIL_TEMPLATE_KEYS.COURSE_DRIP_UNLOCK;
    case NotificationType.COURSE_CERTIFICATE_READY:
      return MAIL_TEMPLATE_KEYS.COURSE_CERTIFICATE_READY;
    default:
      return null;
  }
}

/** Build template variables from a notification payload for dedicated course mail templates. */
export function buildNotificationMailVariables(
  type: NotificationType,
  payload: Record<string, unknown>,
  href: string,
): Record<string, unknown> {
  const courseTitle = typeof payload.courseTitle === 'string' ? payload.courseTitle : 'Course';
  const base = { href };

  switch (type) {
    case NotificationType.COURSE_ENROLLED:
      return { ...base, courseTitle };
    case NotificationType.COURSE_PURCHASE_RECEIPT: {
      const amountCents =
        typeof payload.amountCents === 'number' ? payload.amountCents : undefined;
      const currency = typeof payload.currency === 'string' ? payload.currency : 'usd';
      const amountLabel =
        typeof payload.amountLabel === 'string'
          ? payload.amountLabel
          : amountCents != null
            ? formatCoursePurchaseAmount(amountCents, currency)
            : '';
      return {
        ...base,
        courseTitle,
        amountLabel,
        receiptUrl: typeof payload.receiptUrl === 'string' ? payload.receiptUrl : href,
      };
    }
    case NotificationType.COURSE_DRIP_UNLOCK:
      return {
        ...base,
        courseTitle,
        moduleTitle: typeof payload.moduleTitle === 'string' ? payload.moduleTitle : 'New module',
      };
    case NotificationType.COURSE_CERTIFICATE_READY:
      return {
        ...base,
        courseTitle,
        certificateCode:
          typeof payload.certificateCode === 'string' ? payload.certificateCode : undefined,
      };
    default:
      return {
        ...base,
        summary:
          typeof payload.summary === 'string' ? payload.summary : 'New activity on Loamify',
      };
  }
}
